export default "__VITE_ASSET__DuUiEi9C__"